/* app/js/data-limits-impact.js — Site settings → Data limits: how much a retention window removes, and "Purge now".
 *
 * Sits under the fields interactions.js draws in [data-gs="dl-fields"]. Every change to "Recording retention" or
 * "Screenshot retention" asks GET /sites/data-limits/preview with the values in the form (not yet saved), and shows
 * what is stored now and how much those windows would delete, in MB. "Purge now" saves the form first when it has
 * unsaved changes (after a confirmation that names the size), then POST /sites/data-limits/purge deletes it — the same
 * code the nightly clean-up runs. EN + NL strings live here, like app-sites.js.
 */
(function () {
  'use strict';
  var STR = {
    en: {
      title: 'Storage for heatmaps and recordings', now: 'Stored now', shots: 'Heatmap screenshots', grid: 'Heatmap data',
      recs: 'Session recordings', total: 'Total', rows: 'rows', row1: 'row', files: 'files', file1: 'file', sess: 'recordings', sess1: 'recording', shot1: 'heatmap screenshot', shotN: 'heatmap screenshots', budget: 'files use %used% of your %mb% budget',
      removes: 'With these limits, %size% goes:', nothing: 'Nothing is older than these limits — nothing to remove.',
      keep: 'Kept forever (0 days) — nothing is removed.', older: 'older than %d% days', purge: 'Purge now', purgeN: 'Purge %size% now',
      confirmSave: 'Save these limits and permanently delete %size% now?\n\n%list%\n\nThis cannot be undone.',
      confirm: 'Permanently delete %size% now?\n\n%list%\n\nThis cannot be undone.',
      done: 'Removed %size%: %list%.', doneNone: 'Nothing needed removing.', err: 'Could not purge right now — try again in a minute.',
      nightly: 'The nightly clean-up removes this automatically; Purge does it now. Heatmap data is stored in the database, so its size is an estimate (≈).',
      loading: 'Calculating…', oldest: 'oldest %date%'
    },
    nl: {
      title: 'Opslag voor heatmaps en opnames', now: 'Nu opgeslagen', shots: 'Heatmap-schermafbeeldingen', grid: 'Heatmap-gegevens',
      recs: 'Sessie-opnames', total: 'Totaal', rows: 'rijen', row1: 'rij', files: 'bestanden', file1: 'bestand', sess: 'opnames', sess1: 'opname', shot1: 'heatmap-schermafbeelding', shotN: 'heatmap-schermafbeeldingen', budget: 'bestanden gebruiken %used% van je budget van %mb%',
      removes: 'Met deze limieten verdwijnt %size%:', nothing: 'Niets is ouder dan deze limieten — er valt niets te verwijderen.',
      keep: 'Voor altijd bewaard (0 dagen) — er wordt niets verwijderd.', older: 'ouder dan %d% dagen', purge: 'Nu opschonen', purgeN: '%size% nu opschonen',
      confirmSave: 'Deze limieten opslaan en nu %size% definitief verwijderen?\n\n%list%\n\nDit kan niet ongedaan worden gemaakt.',
      confirm: 'Nu %size% definitief verwijderen?\n\n%list%\n\nDit kan niet ongedaan worden gemaakt.',
      done: '%size% verwijderd: %list%.', doneNone: 'Er hoefde niets verwijderd te worden.', err: 'Opschonen lukt nu niet — probeer het over een minuut opnieuw.',
      nightly: 'De nachtelijke opschoning doet dit automatisch; Opschonen doet het nu. Heatmap-gegevens staan in de database, dus die grootte is een schatting (≈).',
      loading: 'Berekenen…', oldest: 'oudste %date%'
    }
  };
  function S(k, v) {
    var t = STR[(window.GS && GS.locale === 'nl') ? 'nl' : 'en'];
    var s = t[k] != null ? t[k] : (STR.en[k] || k);
    if (v) for (var x in v) s = s.split('%' + x + '%').join(v[x]);
    return s;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function num(n) { return (+n || 0).toLocaleString(); }
  function size(b) {
    b = +b || 0;
    if (b < 1024) return b + ' B';
    if (b < 1048576) return (b / 1024).toFixed(1) + ' KB';
    if (b < 1073741824) return (b / 1048576).toFixed(1) + ' MB';
    return (b / 1073741824).toFixed(2) + ' GB';
  }
  function siteId() { var a = (window.GS && GS.sites) || []; var s = a.filter(function (x) { return x.public_key === GS.site; })[0] || a[0]; return s ? s.id : 0; }
  function fields() { return document.querySelector('[data-gs="dl-fields"]'); }

  var box, timer, seq = 0, last = null;

  function css() {
    if (document.querySelector('style[data-dl-impact]')) return;
    var st = document.createElement('style'); st.setAttribute('data-dl-impact', '');
    st.textContent =
      '.gs-dli{margin-top:18px;border:1px solid var(--line,#E7ECF2);border-radius:10px;padding:14px 16px;background:var(--bg-2,#F8FAFC)}' +
      '.gs-dli-h{font-weight:700;font-size:14px;margin-bottom:10px}' +
      '.gs-dli-row{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:4px 12px;font-size:13px;padding:5px 0;border-top:1px solid var(--line,#EEF1F5)}' +
      '.gs-dli-row:first-of-type{border-top:0}' +
      '.gs-dli-row .v{text-align:right;font-variant-numeric:tabular-nums;font-weight:600;white-space:nowrap}' +
      '.gs-dli-row .m{grid-column:1/-1;font-size:11.5px;color:var(--muted,#8C95A1);margin-top:-2px}' +
      '.gs-dli-tot{font-weight:700}' +
      '.gs-dli-bar{height:6px;border-radius:3px;background:#E5E9F0;overflow:hidden;margin:6px 0 2px}' +
      '.gs-dli-bar>div{height:100%;background:var(--accent,#1FA463)}' +
      '.gs-dli-bar.warn>div{background:#F59E0B}.gs-dli-bar.bad>div{background:#DC2626}' +
      '.gs-dli-out{margin-top:12px;padding:10px 12px;border-radius:8px;background:#FEF3C7;color:#78350F;font-size:13px}' +
      '.gs-dli-out.none{background:#E7F5EC;color:#14532D}' +
      '.gs-dli-out ul{margin:6px 0 0;padding-left:18px}' +
      '.gs-dli-act{display:flex;flex-wrap:wrap;gap:8px 12px;align-items:center;margin-top:12px}' +
      '.gs-dli-note{font-size:11.5px;color:var(--muted,#8C95A1);margin-top:10px}' +
      '.gs-dli-msg{font-size:12.5px}';
    (document.head || document.documentElement).appendChild(st);
  }

  function mount() {
    var f = fields(); if (!f) return false;
    if (box && document.body.contains(box)) return true;
    css();
    box = document.createElement('div'); box.className = 'gs-dli'; box.setAttribute('data-gs', 'dl-impact');
    box.innerHTML = '<div class="gs-dli-h">' + esc(S('title')) + '</div><div data-dli="body" class="gs-muted small">' + esc(S('loading')) + '</div>';
    f.parentNode.insertBefore(box, f.nextSibling);
    return true;
  }

  /** The value a retention field stands for: what is typed, else the plan default shown as its placeholder. */
  function daysOf(key) {
    var el = document.querySelector('[data-dl="' + key + '"]'); if (!el) return null;
    if (el.value !== '') return Math.max(0, parseInt(el.value, 10) || 0);
    var m = (el.getAttribute('placeholder') || '').match(/(\d+)/);
    return m ? parseInt(m[1], 10) : null;
  }

  function refresh() {
    if (!mount()) return;
    var s = siteId(); if (!s || !window.GS || !GS.api) return;
    var rec = daysOf('rec_days'), shot = daysOf('shot_days');
    var q = '/sites/data-limits/preview?site_id=' + s + (rec != null ? '&rec_days=' + rec : '') + (shot != null ? '&shot_days=' + shot : '');
    var my = ++seq;
    GS.api(q).then(function (r) {
      if (my !== seq) return;
      if (!r || !r.ok || !r.data || !r.data.ok) { body().innerHTML = '<span class="gs-muted small">' + esc(S('err')) + '</span>'; return; }
      last = r.data; draw(r.data);
    }).catch(function () {});
  }
  function pl(n, one, many) { return num(n) + ' ' + S(n === 1 ? one : many); }
  function body() { return box.querySelector('[data-dli="body"]'); }

  function lines(d, part) {        // the parts that go, as text lines
    var o = d[part], out = [];
    if (o.screenshots.count) out.push(pl(o.screenshots.count, 'shot1', 'shotN') + ' (' + size(o.screenshots.bytes) + ', ' + S('older', { d: d.shot_days }) + ')');
    if (o.grid.rows) out.push(num(o.grid.rows) + ' ' + S('grid').toLowerCase() + ' ' + S(o.grid.rows === 1 ? 'row1' : 'rows') + ' (≈ ' + size(o.grid.bytes) + ', ' + S('older', { d: d.shot_days }) + ')');
    if (o.recordings.count) out.push(pl(o.recordings.count, 'sess1', 'sess') + ' (' + size(o.recordings.bytes) + ', ' + S('older', { d: d.rec_days }) + ')');
    return out;
  }

  function draw(d) {
    var st = d.stored, rm = d.remove, lim = (d.storage && d.storage.limit_mb) || 0;
    var row = function (label, value, meta) {
      return '<div class="gs-dli-row"><span>' + esc(label) + '</span><span class="v">' + value + '</span>' + (meta ? '<span class="m">' + esc(meta) + '</span>' : '') + '</div>';
    };
    var old = function (k) { return d.oldest && d.oldest[k] ? S('oldest', { date: d.oldest[k] }) : ''; };
    var h = '<div class="small fw-semibold mb-1">' + esc(S('now')) + '</div>';
    h += row(S('shots'), esc(size(st.screenshots.bytes)) + ' <span class="gs-muted">· ' + esc(pl(st.screenshots.count, 'file1', 'files')) + '</span>', old('screenshots'));
    h += row(S('grid'), '≈ ' + esc(size(st.grid.bytes)) + ' <span class="gs-muted">· ' + esc(pl(st.grid.rows, 'row1', 'rows')) + '</span>', old('grid'));
    h += row(S('recs'), esc(size(st.recordings.bytes)) + ' <span class="gs-muted">· ' + esc(pl(st.recordings.count, 'sess1', 'sess')) + '</span>', old('recordings'));
    var files = st.screenshots.bytes + st.recordings.bytes;
    h += '<div class="gs-dli-row gs-dli-tot"><span>' + esc(S('total')) + '</span><span class="v">' + esc(size(st.bytes)) + '</span></div>';
    if (lim > 0) {
      var pct = Math.min(100, files / (lim * 1048576) * 100);
      h += '<div class="gs-dli-bar' + (pct >= 100 ? ' bad' : pct >= 80 ? ' warn' : '') + '"><div style="width:' + pct.toFixed(1) + '%"></div></div>' +
           '<div class="gs-muted small">' + esc(S('budget', { used: size(files), mb: size(lim * 1048576) })) + '</div>';
    }
    var list = lines(d, 'remove');
    if (!d.rec_days && !d.shot_days) h += '<div class="gs-dli-out none">' + esc(S('keep')) + '</div>';
    else if (!list.length) h += '<div class="gs-dli-out none">' + esc(S('nothing')) + '</div>';
    else h += '<div class="gs-dli-out"><b>' + esc(S('removes', { size: (rm.grid.bytes && !rm.screenshots.bytes && !rm.recordings.bytes ? '≈ ' : '') + size(rm.bytes) })) + '</b><ul>' +
              list.map(function (l) { return '<li>' + esc(l) + '</li>'; }).join('') + '</ul></div>';
    h += '<div class="gs-dli-act"><button type="button" class="btn btn-outline-danger btn-sm" data-dli="purge"' + (list.length ? '' : ' disabled') + '>' +
         '<i class="bi bi-trash3 me-1"></i>' + esc(list.length ? S('purgeN', { size: size(rm.bytes) }) : S('purge')) + '</button>' +
         '<span class="gs-dli-msg" data-dli="msg"></span></div>';
    h += '<div class="gs-dli-note">' + esc(S('nightly')) + '</div>';
    body().innerHTML = h;
    var b = box.querySelector('[data-dli="purge"]'); if (b) b.addEventListener('click', purge);
  }

  /** The form as /sites/data-limits takes it (same rules as interactions.js: blank = plan default). */
  function formValues() {
    var dl = {};
    document.querySelectorAll('[data-dl]').forEach(function (el) {
      var k = el.getAttribute('data-dl'), v = el.value;
      if (v === '' || v == null) return;
      dl[k] = (k === 'mode') ? v : (+v || 0);
    });
    return dl;
  }

  function purge() {
    var d = last; if (!d) return;
    var s = siteId(); if (!s) return;
    var list = lines(d, 'remove'); if (!list.length) return;
    var unsaved = d.rec_days !== d.saved.rec_days || d.shot_days !== d.saved.shot_days;
    var msg = S(unsaved ? 'confirmSave' : 'confirm', { size: size(d.remove.bytes), list: list.map(function (l) { return '• ' + l; }).join('\n') });
    if (!window.confirm(msg)) return;
    // Report what the dialog promised (recorded sizes + the grid estimate), not only the bytes of files found on disk.
    var promised = (d.remove.grid.bytes ? '≈ ' : '') + size(Math.max(d.remove.bytes, 0));
    var btn = box.querySelector('[data-dli="purge"]'), out = box.querySelector('[data-dli="msg"]');
    if (btn) btn.disabled = true;
    var step = unsaved
      ? GS.api('/sites/data-limits', { method: 'POST', body: JSON.stringify({ site_id: s, data_limits: formValues() }) })
      : Promise.resolve({ ok: true });
    step.then(function (r) {
      if (!r || !r.ok) throw new Error('save');
      return GS.api('/sites/data-limits/purge', { method: 'POST', body: JSON.stringify({ site_id: s }) });
    }).then(function (r) {
      var x = r && r.data;
      if (!r || !r.ok || !x || !x.ok) throw new Error('purge');
      var parts = [];
      if (x.screenshots) parts.push(pl(x.screenshots, 'shot1', 'shotN'));
      if (x.grid_rows) parts.push(num(x.grid_rows) + ' ' + S('grid').toLowerCase() + ' ' + S(x.grid_rows === 1 ? 'row1' : 'rows'));
      if (x.recordings) parts.push(pl(x.recordings, 'sess1', 'sess'));
      refresh();
      setTimeout(function () {
        var o = box.querySelector('[data-dli="msg"]');
        if (o) { o.className = 'gs-dli-msg text-success'; o.textContent = parts.length ? S('done', { size: promised, list: parts.join(', ') }) : S('doneNone'); }
      }, 400);
    }).catch(function () {
      if (out) { out.className = 'gs-dli-msg text-danger'; out.textContent = S('err'); }
      if (btn) btn.disabled = false;
    });
  }

  function soon() { clearTimeout(timer); timer = setTimeout(refresh, 350); }

  // The fields are drawn (and redrawn after Save / Reset / a site change) by interactions.js: follow them.
  document.addEventListener('input', function (e) { var k = e.target && e.target.getAttribute && e.target.getAttribute('data-dl'); if (k === 'rec_days' || k === 'shot_days') soon(); });
  document.addEventListener('change', function (e) { var k = e.target && e.target.getAttribute && e.target.getAttribute('data-dl'); if (k === 'rec_days' || k === 'shot_days') soon(); });
  function watch() {
    var f = fields(); if (!f || f._dliWatch) return;
    f._dliWatch = 1;
    new MutationObserver(function () { if (f.querySelector('[data-dl]')) soon(); }).observe(f, { childList: true });
    if (f.querySelector('[data-dl]')) soon();
  }
  document.addEventListener('gs:ready', watch);
  document.addEventListener('gs:site-change', function () { last = null; soon(); });
  if (document.readyState !== 'loading') watch(); else document.addEventListener('DOMContentLoaded', watch);
})();
